import { USER_PREFERENCE_SETS } from 'common/utils/constants';

export const generateUniqueName = (existingNames, name) => {
  // Check if name already exists, if not, return name
  if (!existingNames.includes(name)) {
    return name;
  }

  // If name already exists, add a postfix and check again
  let postfix = 1;
  let newName = `${name}-${postfix}`;

  while (existingNames.includes(newName)) {
    postfix++;
    newName = `${name}-${postfix}`;
  }

  return newName;
};

/* Error messages for invalid chartSet JSON data */
export const CHART_SET_ERROR_MESSAGES = {
  MISS_PROP: 'Missing chartSet or charts property.',
  INVALID_JSON: 'Invalid JSON format.',
  INVALID_CHART_SET: 'Invalid chartSet object.',
  INVALID_CHARTS: 'Invalid charts property.',
  INVALID_CHART: (index) => `Invalid chart object at index ${index}.`
};

/**
 * this function is to validate the imported chartSet JSON data
 * @param {object} jsonData
 * @returns true if jsonData is valid, otherwise error message string
 */
export function validateChartSetJSONData(jsonData) {
  if (typeof jsonData !== 'object') {
    return CHART_SET_ERROR_MESSAGES.INVALID_JSON;
  }

  const { chartSet, charts } = jsonData;

  // Validate the structure of the JSON
  if (!jsonData.chartSet || !jsonData.charts) {
    return CHART_SET_ERROR_MESSAGES.MISS_PROP;
  }

  // Validate chartSet object
  if (
    chartSet.name == null ||
    chartSet.category !== USER_PREFERENCE_SETS.CHART_SET ||
    chartSet.default == null ||
    !chartSet.state ||
    !chartSet.state?.query ||
    !chartSet.state?.query?.time
  ) {
    return CHART_SET_ERROR_MESSAGES.INVALID_CHART_SET;
  }

  // Validate charts array
  if (!Array.isArray(charts)) {
    return CHART_SET_ERROR_MESSAGES.INVALID_CHARTS;
  }

  // Validate individual chart objects
  for (let i = 0; i < charts.length; i++) {
    const chart = charts[i];
    const { category, local, preferenceId, default: isDefault, name, state } = chart;

    // Validate local chart
    if (local && !preferenceId) {
      return CHART_SET_ERROR_MESSAGES.INVALID_CHART(i);
    }

    // Validate non-local chart
    if (
      name == null ||
      category !== USER_PREFERENCE_SETS.CHART ||
      isDefault == null ||
      !state ||
      !state?.query ||
      !state?.query?.time ||
      !state?.query?.counters ||
      !state?.query?.actions ||
      !state?.datasets ||
      !state?.scales ||
      !Array.isArray(state?.query?.counters) ||
      !Array.isArray(state?.query?.actions) ||
      !Array.isArray(state?.datasets) ||
      !Array.isArray(state?.scales)
    ) {
      return CHART_SET_ERROR_MESSAGES.INVALID_CHART(i);
    }
  }

  // All checks passed, JSON is valid
  return true;
}
